import { render, staticRenderFns } from "./DogTotalRuleConfig.vue?vue&type=template&id=630b3212&scoped=true"
import script from "./DogTotalRuleConfig.vue?vue&type=script&lang=js"
export * from "./DogTotalRuleConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630b3212",
  null
  
)

export default component.exports